export default __webpack_public_path__ + "alberta-sort-1-to-9.1763607115ddbbfcab00.svg";